import "./Footer.scss";
import { FaLocationArrow,FaMobileAlt,FaEnvelope, FaLink } from "react-icons/fa";
import Payment from "../../assets/payments.png"
import {AiOutlineWhatsApp} from "react-icons/ai"
import {ImLocation} from "react-icons/im"
import { useContext} from "react";
import MyContext from "../../Uttis/MyContext";







const Footer = () => {
    

const {navigate,location} = useContext(MyContext)
  
   
    
 const isFooterVisible = ['/vxeditor','/admino']
  
if (location.pathname.match(/^\/(html|learning|css|certi-deetails|student-registration|css-advance|javascript|project|reactjs|react-native|vxeditor|express-js|excel|cyber-security|php)\//) || isFooterVisible.includes(location.pathname)) { 
    return null;
  }
 

    return <footer className="footer">
    <div className="footer-content">
      


        <div className="col">
      <div className="tmitless">About</div>

      <div className="c-item">
        <div
          className="text"
          style={{
            cursor: "default",
            marginBottom: "20px",
            lineHeight: "1.6",
          }}
        >
          "V-Ex Tech Solution is a software development company that provides
          innovative software, applications, and professional internship
          programs."
        </div>
      </div>

      {/* Address */}
      <div className="c-item">
        <FaLocationArrow />
        <div className="text">
          <a
            href="https://share.google/8MvFwqUe5fouEQVey"
            target="_blank"
            rel="noopener noreferrer"
            title="View on Google Maps"
          >
            301, Dhun Complex, Nizampura, Opp Pavan Park Society, Nava Yard Road,
            Above Riya Bridal, Vadodara - 390002
          </a>
        </div>
      </div>

      {/* Phone */}
      <div className="c-item">
        <FaMobileAlt />
        <div className="text">
          <a href="tel:+919664768292" title="Call us">
            +91 96647 68292
          </a>
        </div>
      </div>

      {/* Email */}
      <div className="c-item">
        <FaEnvelope />
        <div className="text">
          <a href="mailto:hrteam@v-extechsolution.in" title="Send an email">
            hrteam@v-extechsolution.in
          </a>
        </div>
      </div>

      {/* WhatsApp */}
      <div className="c-item">
        <AiOutlineWhatsApp />
        <div className="text">
          <a
            href="https://wa.me/919664768292"
            target="_blank"
            rel="noopener noreferrer"
            title="Chat on WhatsApp"
          >
            Chat on WhatsApp
          </a>
        </div>
      </div>

      {/* Map Shortcut */}
      <div className="c-item">
        <ImLocation />
        <div className="text">
          <a
            href="https://share.google/8MvFwqUe5fouEQVey"
            target="_blank"
            rel="noopener noreferrer"
            title="View Google Map Location"
          >
            Google Map Location
          </a>
        </div>
      </div>
    </div>

       <div className="col">
        <div className="tmitless">V-Ex World</div>
        <span className="text" onClick={() => window.open('https://v-extechsolution.in/')}>V Ex Tech Solution</span>
        <span className="text" onClick={() => window.open('https://components.v-extechsolution.in/')}>Open Souce Ui</span>
        <span className="text" onClick={() => window.open('https://vhx.v-extechsolution.in/')}>VHX View</span>
        <span className="text" onClick={() =>window.open('https://veerconsultancyglobal.com/')}>Veer Consultancy</span>
       <span className="text" onClick={() =>window.open('https://vemox.v-extechsolution.in/')}>Vemox</span>
       
   

       
        
        </div>

      

      <div className="col">
  <div className="tmitless">Services</div>

  <span className="text">Web Design & Development</span>
  <span className="text">Mobile App Development</span>
  <span className="text">Custom Software Development</span>
  <span className="text">E-Commerce Solutions</span>
  <span className="text">Admin Panel & Dashboard Development</span>
  <span className="text">Data Analytics & Visualization</span>
  <span className="text">Digital Marketing & SEO</span>
  <span className="text">IT Consulting & Automation</span>
  <span className="text">Internship & Training Programs</span>
</div>

      

        <div className="col">
        <div className="tmitless">Quick Links</div>
        <span className="text" onClick={() => navigate('/tools')}>Tools</span>
        
        <span className="text" onClick={() => navigate('/vxeditor')}>Code Editor</span>
        <span className="text" onClick={() =>navigate('/certi-details')}>Verify Certificate</span>
        <span className="text" onClick={() =>navigate('/student-registration')}>Student Registration</span>
        <span className="text" onClick={() =>navigate('/internship-report')}>Internship-report</span>
        <span className="text" onClick={() =>navigate('/terms-condition')}>Terms And Condition</span>
         <span className="text" onClick={() =>window.open('https://chooseurcareer.com')}>Build your site </span>
   

       
        
        </div>
        
    </div>

    <div className="bottom-bar">
        <div className="bottom-bar-content">
            <div className="text">
                &#169; Copyrights Reserved - V-Ex Tech 2023 .Software Solution.
            </div>
            <img src={Payment}/>
        </div>
    </div>


    </footer>
  
   
}

export default Footer;